<div class="div-mask-white">
  <div class="modal-delete-template">
      <button (click)="hiddenModalInfo()"  mat-icon-button class="btn-close-modal">
          <mat-icon aria-label="Example icon-button with a heart icon">close</mat-icon>
        </button>

      <div class="title-header-modal">
          <div class="mat-card-title-modal">
            <div class="div-img-alert">
              <img [src]="dataForModal.image" alt="ICONO"/>
            </div>
            <h3 class="title-mod"> {{dataForModal.title}}</h3>

          </div>
      </div>

      <div class="div-body-modal">
          <mat-card-content>
             {{dataForModal.contentBody}}
          </mat-card-content>
      </div>

      <div class="div-footer-buttons">
          <div class="div-buttons">
              <button (click)="generateAction()"  class="btn-confirm" mat-raised-button color="warn">{{dataForModal.textButtonConfirm}}</button>
          </div>
      </div>
  </div>
</div>
